import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-10ca47b4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "about-us-box header-top"
};
const _hoisted_2 = {
  class: "about-us-box-content"
};
const _hoisted_3 = {
  class: "image-top-box"
};
const _hoisted_4 = {
  class: "top-text wow bounceInDown"
};
const _hoisted_5 = {
  class: "left-text wow bounceInLeft"
};
const _hoisted_6 = {
  class: "content"
};
const _hoisted_7 = {
  class: "content-title"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "wow bounceInLeft"
}, "精易科技", -1));

const _hoisted_9 = {
  class: "title-bottom-line"
};
const _hoisted_10 = {
  class: "content-tab-box"
};
const _hoisted_11 = ["onMouseover"];
const _hoisted_12 = {
  key: 0,
  class: "content-1-box common-flex-direction-center"
};
const _hoisted_13 = {
  class: "common-flex-direction-center"
};

const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"title wow fadeInDown\" data-v-10ca47b4>揭阳市揭东区精易科技有限公司</div><div class=\"detail wow fadeInDown\" data-v-10ca47b4>校园外卖，校园跑腿，校园团购，校园零食，信息发布，代取快递，二手市场，寻物启事，表白墙，任务悬赏</div><div class=\"line wow fadeInLeft\" data-v-10ca47b4></div><div class=\"des\" data-v-10ca47b4><div class=\"wow fadeInRight\" data-wow-delay=\"0.1s\" data-v-10ca47b4> 迪想校园是精易科技有限公司旗下校园平台，适合想在校园进行配送创业、跑腿创业、校园资源整合创业的同学。迪想校园关注校园分类信息，为大学生 提供一个综合性校园生活服务平台，由本校学生团队管理和运营,是-一个以大学校园为单元，将学生需求和校园圈内及周边商户进行高效整合,主要业务产 品有：校园外卖、校园跑腿、校园零食、校园资讯、表白墙，任务悬赏，二手交易市场，寻物启事等。 </div><div class=\"wow fadeInLeft\" data-wow-delay=\"0.2s\" data-v-10ca47b4> 迪想校园合作人招募计划，旨在为全国大学生搭建创新创业实践平台，总部提供系统技术平台及各项服务支持（运营指导、多对一售后交流、跟踪式教 学、阶段发展规划、美工设计及功能迭代更新等），助力大学生成长、成才、成功。我们坚信没有愿景的企业做不大，没有情怀的创业者走不远。助力高 校平台建设，我们一直在行动! </div></div>", 4);

const _hoisted_18 = {
  class: "slide-box wow fadeInLeft"
};
const _hoisted_19 = ["src"];
const _hoisted_20 = {
  key: 1,
  class: "content-2-box common-flex-direction-center"
};
const _hoisted_21 = ["data-wow-delay"];
const _hoisted_22 = {
  class: "title"
};
const _hoisted_23 = {
  class: "des"
};
const _hoisted_24 = {
  key: 2,
  class: "content-3-box common-flex-direction-center"
};
const _hoisted_25 = ["data-wow-delay"];
const _hoisted_26 = {
  class: "item-box-left"
};
const _hoisted_27 = {
  class: "item-box-left-content"
};
const _hoisted_28 = {
  class: "title"
};
const _hoisted_29 = {
  class: "des"
};

const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item-box-center"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "top"
}, [/*#__PURE__*/_createElementVNode("div")]), /*#__PURE__*/_createElementVNode("div", {
  class: "bottom"
})], -1));

const _hoisted_31 = {
  class: "item-box-right"
};
const _hoisted_32 = {
  class: "item-box-right-content"
};
const _hoisted_33 = {
  class: "title"
};
const _hoisted_34 = {
  class: "des"
};
const _hoisted_35 = {
  key: 3
};
const _hoisted_36 = {
  class: "content-4-box common-flex-direction-center"
};

const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title wow fadeInDown"
}, "商务合作", -1));

const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line wow fadeInLeft"
}, null, -1));

const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "address wow fadeInDown"
}, "地址：广东省揭阳市揭东区玉湖镇玉湖雅苑5栋4梯E205", -1));

const _hoisted_40 = {
  class: "code-box"
};
const _hoisted_41 = {
  class: "phone wow fadeInDown"
};
const _hoisted_42 = ["src"];

const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "des wow zoomIn"
}, "扫码添加渠道经理企业微信，立即咨询了解", -1));

const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "container"
}, null, -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Header = _resolveComponent("Header");

  const _component_el_carousel_item = _resolveComponent("el-carousel-item");

  const _component_el_carousel = _resolveComponent("el-carousel");

  const _component_Footer = _resolveComponent("Footer");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Header, {
    activeIndex: 6,
    siteInfo: $data.siteInfo
  }, null, 8, ["siteInfo"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_withDirectives(_createElementVNode("div", _hoisted_4, "迪想校园", 512), [[_vShow, $data.showTopImage]]), _withDirectives(_createElementVNode("div", _hoisted_5, "启迪梦想，共造美好校园！", 512), [[_vShow, $data.showTopImage]])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_Transition, {
    name: "width-increase"
  }, {
    default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_9, null, 512), [[_vShow, $data.showTopImage]])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tabList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["tab-box-item", $data.tabIndex == index ? 'active' : '']),
      key: index,
      onMouseover: $event => $options.changeTab(index)
    }, _toDisplayString(item), 43, _hoisted_11);
  }), 128))]), $data.tabIndex == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", _hoisted_18, [_createVNode(_component_el_carousel, {
    interval: 40000,
    type: "card",
    "indicator-position": "none"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.slideList, item => {
      return _openBlock(), _createBlock(_component_el_carousel_item, {
        key: item
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          class: "image",
          src: item,
          alt: ""
        }, null, 8, _hoisted_19)]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  })])])])) : _createCommentVNode("", true), $data.tabIndex == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.content2List, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "item-box wow fadeInDown",
      "data-wow-delay": index * 0.1 + 's',
      key: index
    }, [_createElementVNode("div", _hoisted_22, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_23, _toDisplayString(item.des), 1)], 8, _hoisted_21);
  }), 128))])) : _createCommentVNode("", true), $data.tabIndex == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.content3List, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "item-box wow fadeInDown",
      "data-wow-delay": index * 0.1 + 's',
      key: index
    }, [_createElementVNode("div", _hoisted_26, [_withDirectives(_createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_29, _toDisplayString(item.des), 1)], 512), [[_vShow, index % 2 == 0]])]), _hoisted_30, _createElementVNode("div", _hoisted_31, [_withDirectives(_createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_34, _toDisplayString(item.des), 1)], 512), [[_vShow, index % 2 != 0]])])], 8, _hoisted_25);
  }), 128))])) : _createCommentVNode("", true), $data.tabIndex == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_35, [_withDirectives(_createElementVNode("div", _hoisted_36, [_hoisted_37, _hoisted_38, _hoisted_39, _createElementVNode("div", _hoisted_40, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.content4List, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "code-box-item",
      key: index
    }, [_createElementVNode("div", _hoisted_41, _toDisplayString(item.title), 1), _createElementVNode("img", {
      class: "image wow zoomIn",
      src: item.image,
      alt: ""
    }, null, 8, _hoisted_42)]);
  }), 128))]), _hoisted_43, _hoisted_44], 512), [[_vShow, $data.tabIndex == 3]])])) : _createCommentVNode("", true)])]), _createVNode(_component_Footer, {
    siteInfo: $data.siteInfo
  }, null, 8, ["siteInfo"])]);
}